import { useTranslation } from "react-i18next";

const submissionBankOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "CITIC",
      title: t("options.submissionBank.citic"),
      value: "CITIC",
    },
    {
      key: "FUBON",
      title: t("options.submissionBank.fubon"),
      value: "FUBON",
    },
  ];

  if (typeof list === "string") {
    if (list.toLowerCase() === "all") return options;
    return options.filter((option) =>
      option.tag?.some((tag) => tag === list.toLowerCase()),
    );
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default submissionBankOptions;
